import { render, staticRenderFns } from "./Filhos.vue?vue&type=template&id=31a4399b&scoped=true&"
import script from "./Filhos.vue?vue&type=script&lang=js&"
export * from "./Filhos.vue?vue&type=script&lang=js&"
import style0 from "./Filhos.vue?vue&type=style&index=0&id=31a4399b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a4399b",
  null
  
)

export default component.exports